import { ProfileType } from "@/@types/response";
import { profile } from "@/libs/auth";
import { getCurrentLocation } from "@/utils/helper";
import { LatLngExpression, LatLngTuple } from "leaflet";
import { create } from "zustand";

interface GeolocationType {
  location_data: {
    value: LatLngExpression | LatLngTuple | null;
    status: "loading" | "denied" | "success" | "";
  };
  setLocation: () => Promise<void>;
}
export const useGeolocationStore = create<GeolocationType>((set) => ({
  location_data: {
    status: "",
    value: null,
  },
  async setLocation() {
    try {
      const location = await getCurrentLocation();
      set((prev) => ({
        ...prev,
        location_data: {
          value: location ? [location.lat, location.lng] : null,
          status: location?.lat ? "success" : "denied",
        },
      }));
    } catch (error) {
      console.log({ error: error?.toString() });
      set((prev) => ({
        ...prev,
        location_data: {
          value: null,
          status: location ? "success" : "denied",
        },
      }));
    }
  },
}));
